/*
 * @Email: zheniscool@163.com
 * @FilePath: /cbibank-web-corporbank/src/utils/colors/index.js
 * @Date: 2022-01-20 17:41:13
 * @Author: zhangzhen
 * @LastEditTime: 2022-01-20 17:44:29
 */
export function getStateColor (stateCategory, state) {
  const { successState, failState } = stateCategory
  if (successState.includes(state)) {
    return '#27CBA4'
  } else if (failState.includes(state)) {
    return '#F34359'
  } else {
    return '#FF8D4F'
  }
}
